
import { Button, Grid } from "@mui/material"
import { useNavigate } from "react-router-dom";
import { VisuallyHiddenInput } from "../../../theme/originalTheme";
import { DateFormScreen, SelectSencillo, TextFormNumber } from "../../components";
import { iconos, mediosPago } from "../../../data";
import { useValidarRoles } from "../../../hooks";
import { useFormOpStore, useUsuariosStore } from "../../../stores";


import 'dayjs/locale/es';


export const BotonesDeCompletarOrden = ({ funcion, url }) => {


    const navigate = useNavigate();
    const { formOp, setFormValue } = useFormOpStore();
    const { usuarioVenta } = useUsuariosStore();
    const { permitirXRol } = useValidarRoles();
    const isAdmin = permitirXRol('SUPERADMIN', 'ADMINISTRADOR');


    const handleChange = ({ target }) => {
        const { name, value } = target;
        setFormValue(name, value);
    };


    const handleChangeStart = (newValue) => {
        setFormValue('fechaEntrega', newValue.toDate());
    };


    const handleFileChange = (e) => {
        const file = e.target.files[0];
        if(file) setFormValue("imgPago", file);
    };


    const handlePictureClick = () => {
        document.querySelector('#fileSelector').click();
    }


    const handleCheckout = () => {
        navigate(`${url}`);
    }



    return (

        <Grid container sx={{ display:'flex', flexDirection:'column', mt:1 }}>

            {(isAdmin) &&
                <Grid container sx={{mt:2}}> 
                    <Grid item xs={12}>
                        <DateFormScreen
                            label="Fecha de Entrega"
                            value={formOp.fechaEntrega}
                            onChange={handleChangeStart}
                        />
                    </Grid>

                    <Grid item xs={12} my={1}>
                        <TextFormNumber 
                            name="abono"
                            size="small"
                            fullWidth
                            autoComplete='off'
                            label="Aplicar Abono"
                            onChange={ handleChange } 
                            value={ formOp.abono }
                        />
                    </Grid>

                    <Grid item xs={12} my={1}>
                        <SelectSencillo 
                            name="banco"
                            size="small"
                            fullWidth
                            label="Seleccione Un Banco"
                            options={mediosPago}
                            onChange={ handleChange }
                            value={ formOp.banco }

                        />
                    </Grid>

                    <div className="file-upload-container">
                        <input 
                            type="file" 
                            id="fileSelector"
                            className="boton-file"
                            onChange={ handleFileChange }
                            name="file"
                            accept="image/*"
                        />
                    </div>

                    <Button sx={{my:1}} variant={(formOp.imgPago) ? "contained" : "outlined"} color="secondary"
                        startIcon={iconos['subirimg']} fullWidth onClick={ handlePictureClick }
                    >
                        Subir Imagen
                        <VisuallyHiddenInput type="file" />
                    </Button>
                </Grid>
            }


            {(usuarioVenta) 
            ?   <Grid item xs={12} sx={{mt:2}}>
                    <Button fullWidth color='secondary' variant="contained" onClick={ funcion }>
                        Completar Orden
                    </Button>
                </Grid>  

            :    <Grid item xs={12}>
                    <Button fullWidth color='primary' variant="contained" sx={{my:2}} onClick={ handleCheckout }>
                        Checkout
                    </Button>
                </Grid>
            }
        </Grid>
    )

    
}
